import { createBrowserRouter, Navigate } from "react-router"
import Layout from "@/layout"
import LoginPage from "@/pages/auth/LoginPage"
import ProtectedRoute from "./ProtectedRoute"
import LeadManagement from "@/pages/people/lead"
import Student from "@/pages/people/student"
import DomainLv1 from "@/pages/domain/domain-lv1"
import DomainLv2 from "@/pages/domain/domain-lv2"
import TrainingProject from "@/pages/domain/training-project"
import TrainingPlan from "@/pages/training/training-plan"
import TrainingRecord from "@/pages/training/training-record"
import ClassRecords from "@/pages/training/class-records"
import HolidayManagement from "@/pages/training/holiday"
import UserManagement from "@/pages/system/user"
import RoleManagement from "@/pages/system/role"
import DictManagementPage from "@/pages/system/dict"
import FileAssetManagement from "@/pages/resource/file-asset"
import QrCodeManagement from "@/pages/resource/qr-code"
import { isAuthenticated } from "@/utils/auth"

export default createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <Navigate to="/role" replace />,
      },
      {
        path: "/lead",
        element: <LeadManagement />,
      },
      {
        path: "/student",
        element: <Student />,
      },
      {
        path: "/teacher",
        element: <Navigate to="/user" replace />,
      },
      {
        path: "/domain-lv1",
        element: <DomainLv1 />,
      },
      {
        path: "/domain-lv2",
        element: <DomainLv2 />,
      },
      {
        path: "/training-project",
        element: <TrainingProject />,
      },
      {
        path: "/training-plan",
        element: <TrainingPlan />,
      },
      {
        path: "/training-record",
        element: <TrainingRecord />,
      },
      {
        path: "/class-records",
        element: <ClassRecords />,
      },
      {
        path: "/holidays",
        element: <HolidayManagement />,
      },
      {
        path: "/user",
        element: <UserManagement />,
      },
      {
        path: "/role",
        element: <RoleManagement />,
      },
      {
        path: "/dict",
        element: <DictManagementPage />,
      },
      {
        path: "/file-assets",
        element: <FileAssetManagement />,
      },
      {
        path: "/qr-codes",
        element: <QrCodeManagement />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={isAuthenticated() ? "/" : "/login"} replace />,
  },
])
